import styled from 'styled-components';

import { gridColumn, gridRow } from 'styleUtils/grid';

export const PersonInfo = styled.div`
    text-transform: uppercase;
    text-align: left;
    display: flex;
    align-items: center;
    h4 {
        font-size: 0.9em;
        margin: 0;
    }

    ${gridRow({ start: 1 })}
    ${gridColumn({ start: 2 })}
    margin-left: 20px;
`;
